import {createFileRoute} from '@tanstack/react-router';

import {ArchiveSearchParams} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ImageOverview} from '~components/images/image-overview/ImageOverview';
import {useLabelItems} from '~components/models/model.hooks';

export const Route = createFileRoute('/archive/')({
  component: ArchivePage,
  validateSearch: ArchiveSearchParams.validate,
});

function ArchivePage() {
  const projectLabelItems = useLabelItems({from: 'project'});

  return (
    <BaseLayout>
      <ImageOverview mode='archive' currentLabels={projectLabelItems} />
    </BaseLayout>
  );
}
